import { render, staticRenderFns } from "./TheNotificationBell.vue?vue&type=template&id=68763e06&scoped=true&"
import script from "./TheNotificationBell.vue?vue&type=script&lang=js&"
export * from "./TheNotificationBell.vue?vue&type=script&lang=js&"
import style0 from "./TheNotificationBell.vue?vue&type=style&index=0&id=68763e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68763e06",
  null
  
)

export default component.exports